module.exports = __webpack_public_path__ + "static/media/Andrina.363e1d72.png";